module.exports = __webpack_public_path__ + "static/img/4_1_2.89c746e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4_1_2.png
// module id = pvWG
// module chunks = 1